import React from "react";

export default function Input({ label, value, setValue, placeholder }) {
  return (
    <div className="form-group">
      <div className="form-label-group">
        <label className="form-label" for="default-01">
          {label}
        </label>
      </div>
      <div className="form-control-wrap">
        <input
          type="text"
          value={value}
          className="form-control form-control-lg"
          id="default-01"
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}
